import CloseIcon from "@mui/icons-material/Close";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Button, Dialog, IconButton, Stack, Toolbar, Typography } from "@mui/material";
import { t } from "i18next";
import React, { useState } from "react";
import { IWorkShiftTimeSlot } from "../../models/workShiftTimeSlot/workShiftTimeSlot";

interface CostCenterInfoProps {
    slot?: IWorkShiftTimeSlot;
}

export const CostCenterInfo = (props: CostCenterInfoProps) => {
    const { slot } = props;
    const [dialogOpen, setDialogOpen] = useState(false);

    function onCostCenterClick() {
        if (slot.costCenterComment) {
            setDialogOpen(true);
        }
    }

    return (
        <>
            {slot?.costCenterId ? (
                <Typography variant="h4" onClick={onCostCenterClick}>
                    {slot.costCenterName}
                    {slot.costCenterComment && <InfoOutlinedIcon sx={{ mb: "-3px", ml: "3px" }} fontSize="small" />}
                </Typography>
            ) : (
                <Typography
                    variant="h4"
                    sx={{ color: "gray.main" }}
                >
                    {t("workTime.noCostCenterSelected")}
                </Typography>
            )}

            <Dialog
                fullScreen
                open={dialogOpen}
            >
                <Toolbar>
                    <IconButton
                        edge="start"
                        color="inherit"
                        aria-label="close"
                        onClick={() => setDialogOpen(false)}
                    >
                        <CloseIcon color="action" />
                    </IconButton>
                </Toolbar>

                <Stack
                    direction="column"
                    px={4}
                    flexGrow="1"
                    alignItems="center"
                >
                    <Typography
                        fontSize={24}
                        color="blue.dark"
                        sx={{ lineHeight: 1.2, fontWeight: 600 }}
                        mt={5}
                    >
                        {slot?.costCenterName}
                    </Typography>

                    <Typography
                        fontSize={18}
                        sx={{ lineHeight: 1.2, fontWeight: 600, whiteSpace: "pre-wrap" }}
                        mt={5}
                    >
                        {slot?.costCenterComment}
                    </Typography>

                    <Button sx={{ marginTop: "auto", marginBottom: 4 }} variant="contained" onClick={() => setDialogOpen(false)}>{t("common.close")}</Button>
                </Stack>
            </Dialog>
        </>
    );
};
